﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederSlettingAvRenterDto from '../Models/VeilederSlettingAvRenterDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';
import { satserReducer } from '../../Shared/Scripts/Store/Satser/Reducers';
import { SlettingAvRenterSatser } from '../Utilities/SlettingAvRenterSatserApi';

const rootReducer = combineReducers<VeilederSlettingAvRenterAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    satser: satserReducer,
    epiContext: (
        state: EpiContext<VeilederSlettingAvRenterDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederSlettingAvRenterDto>,
    ): EpiContext<VeilederSlettingAvRenterDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type VeilederSlettingAvRenterAppState = EpiAppStateMedSteg<VeilederSlettingAvRenterDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: SlettingAvRenterSatser | null;
};

export default function configureStore(): Store<VeilederSlettingAvRenterAppState> {
    const valgStateJson = window.localStorage.getItem('state');
    if (valgStateJson != null) {
        const savedState = JSON.parse(valgStateJson) as VeilederSlettingAvRenterAppState;
        return createStore(rootReducer, savedState, applyMiddleware(ReduxThunk));
    }
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
